import { type ReactNode } from 'react';
import { css, styled } from 'styled-components';

const LayoutElement = styled.div<{
  $widthOffset?: number;
}>`
  ${({ $widthOffset = 0 }) => css`
    position: relative;
    transition: width 750ms ease;
    width: ${`calc(100vw - ${$widthOffset}px)`};
    max-width: 1440px;
  `}
`;

export const PageLayout = ({
  children,
  widthOffset = 0,
  ...props
}: {
  readonly children: ReactNode;
  readonly widthOffset?: number;
}) => {
  return (
    <LayoutElement
      $widthOffset={widthOffset}
      {...props}
    >
      {children}
    </LayoutElement>
  );
};
